export default function update(userId, data) {
  const request = indexedDB.open(`search_history_${userId}`, 1);
  request.onsuccess = (e) => {
    const db = e.target.result;
    const tx = db.transaction(Object.keys(data)[0], 'readwrite');
    const req = tx.objectStore(Object.keys(data)[0]).add(Object.values(data)[0]);

    req.onerror = (event) => {
      console.log('Error', event);
    };
  };
}
